// extracted by mini-css-extract-plugin
module.exports = {"structureWrap":"styles_structureWrap__1fhQ5"};